import{Formik, Form, Field,ErrorMessage, useFormikContext, FormikValues} from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import ComboBox from '../../Certificados/ComboBox';
import { Guardaruser } from '../../../interfaces/UsuariosRoles';
import SelectMultiple from '../../Certificados/SelectMultiple';
import AlertService from '../../../services/AlertService';
import Alert from '@mui/material/Alert';
import { CasUserContext, useCasUserContext } from '../../../services/casUserContext';
import { useNavigate } from 'react-router-dom';
import { Button, Input } from '@mui/material';
import Grid from '@mui/material/Grid';
import { GuardarCategoria, ProductoEsperado } from '../../../interfaces/Sistema';
import { Save } from '@mui/icons-material';
import { Categoria } from '../../../interfaces/Sistema';
import CatalogService from '../../../services/CatalogService';
const alertService = new AlertService();
const catalogService = new CatalogService();

interface opcion{
    value:string,
    label: string,
}

interface propsCategoria{
    categoria: GuardarCategoria,
    productosActivos : Array<opcion>
}

export default function IngresoCategoriaProducto(props: propsCategoria){
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const token = casUserContext.token;
    const opciones = [
        { value: '1', label: 'SI' },
        { value: '0', label: 'NO' },
      ];
    
    const vacio:opcion = {value:'', label:''} 
    let decisionInicial: opcion = obtenerDecision(props.categoria.categoria.activo,vacio);
    
    const [selectedDecision, setSelectedDecision] = useState<opcion>(decisionInicial);
    const productosIniciales:Array<opcion>= Array<opcion>()
    props.categoria.productos.map((rol)=>{
        let op: opcion | undefined = props.productosActivos.find((op)=>parseInt(op.value)===rol)
        if(op!=undefined){
            productosIniciales.push(op)
        }
    })

    const [seleccionMultiple, setSeleccionMultiple] = useState(productosIniciales);
    
    
    const handleComboBoxChangeMultiple = (selected: any) => {
        setSeleccionMultiple(selected);
      };

    const handleComboBoxChangeDecision = (selectedDecision: opcion) => {
        setSelectedDecision(selectedDecision);
    };
    const Save = async (values:any, actions: any) =>{
        if(selectedDecision.value===''){
            alertService.alertaAdvertencia('Error','Por favor escoger una opción en el campo Activo')
            return
        }

        let productos = Array<number>()

        let objCategoria: Categoria = {
            iddecinvcategoria: 0,
            nombrecategoria: values.nombreCategoria,
            descripcion: values.descripcion,
            activo: parseInt(selectedDecision.value),
            ncategoria: parseInt(values.numCategoria)
        }

        seleccionMultiple.map((row)=>{
            productos.push( parseInt(row.value))
        })

        let saveCategoria: GuardarCategoria={
            categoria: objCategoria,
            productos: productos,
        }

        if(props.categoria.categoria.iddecinvcategoria===0){
            //SE GUARDA NUEVA CATEGORIA
            alertService.showLoading("Guardando nueva categoría...");
            const resp = await catalogService.GuardarCategoria(saveCategoria,token);
            alertService.hideLoading();
            //console.log(resp)
            if(resp.status.isSuccessfully) {
                alertService.alertaExito("Exito","Nueva categoría guardada");
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                
            }else{
                alertService.alertaAdvertencia("Error",resp.status.messages.toString());
            }

        }else{
            //SE ACTUALIZA CATEGORIA EXISTENTE
            objCategoria.iddecinvcategoria = props.categoria.categoria.iddecinvcategoria;
            alertService.showLoading("Actualizando categoría...");
            const resp = await catalogService.ActualizarCategoriaById(casUserContext.token, props.categoria.categoria.iddecinvcategoria, saveCategoria);
            alertService.hideLoading();
            if(resp.status.isSuccessfully) {
                alertService.alertaExito("Éxito","La categoría ha sido actualizada");
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                
            }else{
                alertService.alertaAdvertencia("Error",resp.status.messages.toString());
            }
        }
    }

    const validationSchema = Yup.object({
        nombreCategoria: Yup.string().required('El campo Nombre es obligatorio')
        
      });

    function obtenerDecision(id: number, porDefecto: opcion):opcion{
        const decision = opciones.find((op)=> parseInt(op.value)===id);
        return decision || porDefecto
    }

    return(
        <Formik

        initialValues={{nombreCategoria: props.categoria.categoria.nombrecategoria!=null ? props.categoria.categoria.nombrecategoria.toString():'' , descripcion:props.categoria.categoria.descripcion!=null ? props.categoria.categoria.descripcion.toString():'', numCategoria:props.categoria.categoria.ncategoria!=null ? props.categoria.categoria.ncategoria:0}}
        validationSchema={validationSchema}
        onSubmit={Save}
        >

        {({ values, handleChange, handleBlur, handleSubmit, setFieldValue })=>(
            <Form>
                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label ><strong>Nombre: </strong></label>
                    </Grid>
                    <Grid item xs={9} md={9}>
                        <Field style={{width:'100%'}} type="text" id="nombreCategoria" name="nombreCategoria" />
                        
                        <ErrorMessage name="nombreCategoria">
                            {(error) => (
                                <Alert severity="error">
                                {error}
                                </Alert>
                            )}
                        </ErrorMessage>
                    </Grid>
                </Grid>
                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label ><strong>Número categoría: </strong></label>
                    </Grid>
                    <Grid item xs={9} md={9}>
                        <Field type='number' id='numCategoria' name='numCategoria'/>
                    </Grid>
                </Grid>

                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label ><strong>Descripción: </strong></label>
                    </Grid>
                    <Grid item xs={9} md={9}>
                        <Field style={{width:'100%'}} as='textarea' id='descripcion' name='descripcion' />
                        <ErrorMessage name="descripcion">
                            {(error) => (
                                <Alert severity="error">
                                {error}
                                </Alert>
                            )}
                        </ErrorMessage>
                    </Grid>
                </Grid>

                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label ><strong>Activo: </strong></label>
                    </Grid>
                    <Grid item xs={9} md={9}>
                        <Field component={ComboBox} options={opciones} onChange={handleComboBoxChangeDecision} placeHolder='Seleccione una opción' name='activo' porDefecto={selectedDecision.value!='' ? selectedDecision : null} ></Field>
                    </Grid>
                </Grid>

                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label><strong>Productos asociados a esta categoría</strong></label>
                    </Grid>
                    <Grid item xs={9} md={9}>
                        <Field  name="productos" component={SelectMultiple} options={props.productosActivos} multiple={true} onChange={handleComboBoxChangeMultiple} placeHolder="Escoga los productos relacionados" default={seleccionMultiple} />
                    </Grid>
                </Grid>

                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Button type="submit" variant="contained"> Guardar</Button>
                </Grid>

                
            </Form>
            
            

        )}

        </Formik>
        
        
    )
}
